import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function FAQ() {
  const headerAnimation = useScrollAnimation({ threshold: 0.2 });
  const faqAnimation = useScrollAnimation({ threshold: 0.1 });
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: '香りは強くないですか？',
      answer:
        'ホワイトリリィの上品で控えめな香りです。強い香りが苦手な方やペットにも安心してお使いいただけます。時間とともに自然に馴染み、ほのかに残る程度の優雅な香りです。'
    },
    {
      question: '犬・猫　以外にも使えますか？',
      answer:
        "はい、犬猫だけではなく、被毛のある他のペットにもお使いいただけます。但し、ペットによって毛質や皮膚の状態が異なるため、使用前に少量を試してみることをお勧めします。アレルギー反応や皮膚の敏感さがないか様子を見ながらお使いください。不安がある場合は、獣医師に相談することもお勧めします。"
    },
    {
      question: '舐めても大丈夫ですか？',
      answer:
        '化粧品原料は、安全性の高いものが使われていますので、舐めても危険はありませんが、故意に飲ませたり、大量に舐めることは避けてください。ご不安な方は、獣医師に相談をしてください。'
    },
    {
      question: 'どのくらいの頻度で使えばいいですか？',
      answer:
        '毎日のブラッシング時や、散歩後、寝る前など、必要に応じてお使いください。シャンプーの代わりではなく、日常ケアの補助としてご活用いただくことをおすすめします。'
    },
    {
      question: '短毛種にも効果はありますか？',
      answer:
        'はい、短毛種にも効果的です。静電気防止や保湿効果により、毛並みを整え、ツヤを与えます。ハンドグルーミングの際にもお使いいただけます。'
    },
    {
      question: 'どこで購入できますか？',
      answer:
        'Deaiwo公式サイト、および提携オンラインストアにてご購入いただけます。\n今後、実店舗での販売を視野にいれております。'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        {/* Header */}
        <div
          ref={headerAnimation.ref}
          className={`text-center mb-20 space-y-6 transition-all duration-1000 ${
            headerAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
          }`}
        >
          <h3
            className="text-sm tracking-[0.3em] text-stone-500 font-light"
            style={{ fontFamily: 'Cormorant, serif' }}
          >
            FAQ
          </h3>
          <h2
            className="text-4xl md:text-5xl leading-relaxed"
            style={{
              fontFamily: 'Noto Serif JP, serif',
              fontWeight: 400,
              color: '#705e44'
            }}
          >
            よくあるご質問
          </h2>
        </div>

        {/* FAQ List */}
        <div ref={faqAnimation.ref} className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className={`border border-stone-200 overflow-hidden transition-all duration-1000 ${
                faqAnimation.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'
              }`}
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-6 flex items-start justify-between gap-6 text-left cursor-pointer group"
              >
                <div className="flex-1 space-y-2">
                  <h4
                    className="text-lg group-hover:text-[#C6A87B] transition-colors"
                    style={{
                      fontFamily: 'Noto Serif JP, serif',
                      fontWeight: 400,
                      color: '#705e44'
                    }}
                  >
                    {faq.question}
                  </h4>
                  {openIndex === index && (
                    <p
                      className="text-sm text-stone-600 leading-loose pt-4"
                      style={{ fontFamily: 'Noto Serif JP, serif', fontWeight: 400 }}
                    >
                      {faq.answer}
                    </p>
                  )}
                </div>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-xl text-[#C6A87B] transition-transform`}
                  ></i>
                </div>
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}